import {
  FeatureCreateResultType, ProjectFeatureCreateConstraint, ProjectFeatureCreateResult,
  ProjectFeatureCreateSelection,
} from '@catcore/types/api-v2';
import {ProjectFeature} from '@catmodules/models/project-feature/types';
import {isArray} from 'util';

export class CreateFeatureResultFactory {

  constructor(private requestResult: any) {
  }

  resolve(): ProjectFeatureCreateResult {
    const result: ProjectFeatureCreateResult = {features: [], constraints: [], selections: [], status: this.determineStatus()};

    switch (result.status) {
      case FeatureCreateResultType.success:
        result.features = this.resolveFeatures();
        break;
      case FeatureCreateResultType.missingSelections:
        result.selections = this.resolveSelections();
        break;
      case FeatureCreateResultType.unfullfiledConstraints:
        result.constraints = this.resolveConstraints();
        break;
    }

    return result;
  }

  private resolveFeatures(): ProjectFeature[] {
    return [this.requestResult as ProjectFeature];
  }

  private resolveSelections(): ProjectFeatureCreateSelection[] {
    const resolved: ProjectFeatureCreateSelection[] = [];

    if (isArray(this.requestResult)) {
      this.requestResult.forEach((item: any) => {
        let isValid = item.hasOwnProperty('name');
        isValid = isValid && item.hasOwnProperty('options');
        isValid = isValid && item.hasOwnProperty('reference');

        if (isValid) {
          resolved.push({
            name: item.name,
            options: item.options.map((option: any) => {
              return {label: option.name, value: option.id};
            }).sort((o1, o2) => o1.label < o2.label ? -1 : 1),
            reference: item.reference,
          });
        }
      });
    }

    return resolved;
  }

  private resolveConstraints(): ProjectFeatureCreateConstraint[] {
    const resolved: ProjectFeatureCreateConstraint[] = [];

    if (isArray(this.requestResult)) {
      this.requestResult.forEach((item: any) => {
        let isValid = item.hasOwnProperty('code');
        isValid = isValid && item.hasOwnProperty('message');
        isValid = isValid && item.hasOwnProperty('property_path');

        if (isValid) {
          resolved.push({code: item.code, message: item.message, property_path: item.property_path});
        }
        const expectedKeys = ['name', 'options', 'reference'];
      });
    }

    return resolved;
  }

  private resolveUntypedErrors(): any[] {
    return this.requestResult;
  }

  private determineStatus(): FeatureCreateResultType {
    let status = FeatureCreateResultType.failed;
    const isSuccess = !isArray(this.requestResult);

    if (isSuccess) {
      status = FeatureCreateResultType.success;
    }

    if (!isSuccess && this.hasMissingConstraintRequests()

    ) {
      status = FeatureCreateResultType.unfullfiledConstraints;
    }

    if (!isSuccess && this.requiresPortSelections()) {
      status = FeatureCreateResultType.missingSelections;
    }

    return status;
  }

  private hasMissingConstraintRequests(): boolean {
    const constraints = this.resolveConstraints();
    return constraints.length > 0;
  }

  private requiresPortSelections(): boolean {
    const constraints = this.resolveSelections();
    return constraints.length > 0;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/utils/create-facture-result-factory.ts